import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface ITicketsState {
  rejectDialog: boolean;
  finishedDialog: boolean;
  forwardDialog: boolean;
  pendingDialog: boolean;
  unpendingDialog: boolean;
  detailDialog: boolean;
  editDialog: boolean;
  editLiveDialog: boolean;
  editNetworkDialog: boolean;
  editAdministrationDialog: boolean;
  rateDialog: boolean;
  currentTicket: any;
}

interface dialogShowStatus {
  name: any;
  value: boolean;
}

interface ITicketData {
  id: number;
  tid: number;
  ticket_number: string;
  status: number;
  is_forward: number;
  is_live_influenced: number;
  remind_times: number;
  create_time: string;
  accept_time: string;
  finish_time: string;
  describe: string;
  remark: string;
  team: {
    name: string;
  };
  creator: {
    id: number;
    name: string;
    account: string;
    workcode: string;
    avatar: string;
  };
  accept_user: {
    id: number;
    name: string;
    account: string;
    workcode: string;
    avatar: string;
  };
  live_room: {
    id: number;
    name: string;
    area: number;
    description: string;
    area_type: {
      id: number;
      name: string;
      area_type: number;
    };
    room_type_name: {
      id: number;
      name: string;
    };
  };
  live_time_range: {
    id: number;
    name: string;
  };
  issue_type: {
    id: number;
    name: string;
    parent_issue_type: string;
    pid: number;
  };
  computer_type: {
    id: number;
    name: string;
  };
  place: {
    id: number;
    name: string;
  };
  subject: {
    id: number;
    name: string;
  };
  location: {
    place: string;
    building: string;
    floor: string;
  };
  live_ticket_type: number;
}

@Module({ dynamic: true, store, name: 'tickets' })
class Tickets extends VuexModule implements ITicketsState {
  public rejectDialog = false
  public finishedDialog = false
  public forwardDialog = false
  public pendingDialog = false
  public unpendingDialog = false
  public detailDialog = false
  public editDialog = false
  public editLiveDialog = false
  public editNetworkDialog = false
  public editAdministrationDialog = false
  public rateDialog = false // 满意度评价弹框
  public currentTicket: any = {}
  public currentTicketIndex?: number = 0
  public defaultTicket: ITicketData = {
    id: 0,
    tid: 0,
    ticket_number: '',
    status: 0,
    is_forward: 0,
    is_live_influenced: 0,
    remind_times: 0,
    create_time: '',
    accept_time: '',
    finish_time: '',
    describe: '',
    remark: '',
    team: {
      name: ''
    },
    creator: {
      id: 0,
      name: '',
      account: '',
      workcode: '',
      avatar: ''
    },
    accept_user: {
      id: 0,
      name: '',
      account: '',
      workcode: '',
      avatar: ''
    },
    live_room: {
      id: 0,
      name: '',
      area: 0,
      description: '',
      area_type: {
        id: 0,
        name: '',
        area_type: 0
      },
      room_type_name: {
        id: 0,
        name: ''
      }
    },
    live_time_range: {
      id: 0,
      name: ''
    },
    issue_type: {
      id: 0,
      name: '',
      parent_issue_type: '',
      pid: 0
    },
    computer_type: {
      id: 0,
      name: ''
    },
    place: {
      id: 0,
      name: ''
    },
    subject: {
      id: 0,
      name: ''
    },
    location: {
      place: '',
      building: '',
      floor: ''
    },
    live_ticket_type: 0
  }

  @Mutation
  private TOGGLE_DIALOG(obj: dialogShowStatus) {
    (this as any)[obj.name] = obj.value
  }

  @Mutation
  private ClOSE_ALL_DIALOG() {
    this.rejectDialog = false
    this.finishedDialog = false
    this.forwardDialog = false
    this.pendingDialog = false
    this.unpendingDialog = false
    this.detailDialog = false
    this.editDialog = false
    this.editLiveDialog = false
    this.editNetworkDialog = false
    this.editAdministrationDialog = false
  }

  @Mutation
  private SET_CURRENTTICKET(obj: any) {
    this.currentTicket = obj
  }

  @Mutation
  private SET_CURRENTTICKETINDEX(index?: number) {
    this.currentTicketIndex = index || 0
  }

  @Action
  public ToggleDialogStatus(obj: dialogShowStatus) {
    this.TOGGLE_DIALOG(obj)
  }

  // 赋值 当前操作的工单对象
  @Action
  public SetCurrentTicket(obj: any) {
    this.SET_CURRENTTICKET(obj.ticket)
    this.SET_CURRENTTICKETINDEX(obj.ticketIndex || 0)
  }

  // 关闭所有弹框
  @Action
  public CloseAllDialog() {
    this.ClOSE_ALL_DIALOG()
  }
}

export const TicketsModule = getModule(Tickets)
